import { render, staticRenderFns } from "./topSalesBySubSeries.vue?vue&type=template&id=a71a29ee&scoped=true"
import script from "./topSalesBySubSeries.vue?vue&type=script&lang=js"
export * from "./topSalesBySubSeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71a29ee",
  null
  
)

export default component.exports